import React, { FC } from 'react';
import { formatNumeric } from 'src/front/common/utils/formUtils';
import { FormRow } from 'src/front/components/FormStyles';
import { FormProps } from 'src/front/components/identity/FormProps';
import useDefaultIssueCountry from 'src/front/components/identity/useDefaultIssueCountry';
import IssueCountry from 'src/front/components/identity/Field/IssueCountry';
import SerialNumber from 'src/front/components/identity/Field/SerialNumber';

// Свидетельство о присвоении ИНН
const Inn: FC<FormProps> = ({ formMethods, handleTextChange, handleCountryChange, countries }) => {
  useDefaultIssueCountry(formMethods, countries);
  return (
    <>
      <FormRow>
        <SerialNumber
          formatter={formatNumeric}
          formMethods={formMethods}
          max={12}
          min={12}
          onChangeHandler={handleTextChange}
        />
        <IssueCountry
          countries={countries}
          formMethods={formMethods}
          onChangeHandler={handleCountryChange}
          disabled
        />
      </FormRow>
    </>
  );
};

export default Inn;
